import http from '@/http'

const URL = '/admin/event-forms'
const URL_FIELD_TYPES = '/admin/field-types'

// ========== FORMS ==========

export const listForms = async (params) => {
  return http.get(URL, { params })
}

export const getForm = async (id) => {
  return http.get(`${URL}/${id}?include=fields,conditions`)
}

export const getFormBuilder = async (id) => {
  return http.get(`${URL}/${id}/builder`)
}

export const getFormPreview = async (id) => {
  return http.get(`${URL}/${id}/preview`)
}

export const createForm = (payload) => {
  return http.post(URL, payload)
}

export const updateForm = (id, payload) => {
  return http.put(`${URL}/${id}`, payload)
}

export const saveFormComplete = (id, payload) => {
  return http.put(`${URL}/${id}/complete`, payload)
}

export const changeFormStatus = (id) => {
  return http.patch(`${URL}/${id}/status`)
}

export const duplicateForm = (id) => {
  return http.post(`${URL}/${id}/duplicate`)
}

export const deleteForm = (id) => {
  return http.delete(`${URL}/${id}`)
}

export const getFormsSelect = async () => {
  return http.get(`${URL}/select`)
}

// ========== FIELD TYPES ==========

export const getFieldTypes = async () => {
  return http.get(URL_FIELD_TYPES)
}

export const getFieldTypesGrouped = async () => {
  return http.get(`${URL_FIELD_TYPES}/grouped`)
}

// ========== FIELDS ==========

export const getFields = async (formId, params) => {
  return http.get(`${URL}/${formId}/fields`, { params })
}

export const getField = async (formId, id) => {
  return http.get(`${URL}/${formId}/fields/${id}`)
}

export const createField = (formId, payload) => {
  return http.post(`${URL}/${formId}/fields`, payload)
}

export const updateField = (formId, id, payload) => {
  return http.put(`${URL}/${formId}/fields/${id}`, payload)
}

export const deleteField = (formId, id) => {
  return http.delete(`${URL}/${formId}/fields/${id}`)
}

export const duplicateField = (formId, id) => {
  return http.post(`${URL}/${formId}/fields/${id}/duplicate`)
}

export const reorderFields = (formId, orderedIds) => {
  return http.patch(`${URL}/${formId}/fields/reorder`, { ordered_ids: orderedIds })
}

// ========== CONDITIONS ==========

export const getConditions = async (formId) => {
  return http.get(`${URL}/${formId}/conditions`)
}

export const createCondition = (formId, payload) => {
  return http.post(`${URL}/${formId}/conditions`, payload)
}

export const updateCondition = (formId, id, payload) => {
  return http.put(`${URL}/${formId}/conditions/${id}`, payload)
}

export const deleteCondition = (formId, id) => {
  return http.delete(`${URL}/${formId}/conditions/${id}`)
}

export const getConditionOperators = async () => {
  return http.get('/admin/form-conditions/operators')
}

export const getConditionActions = async () => {
  return http.get('/admin/form-conditions/actions')
}

// ========== CUSTOM LISTS ==========

export const getCustomLists = () => {
  return http.get('/admin/custom-lists')
}

export default {
  // Forms
  listForms,
  getForm,
  getFormBuilder,
  getFormPreview,
  createForm,
  updateForm,
  saveFormComplete,
  changeFormStatus,
  duplicateForm,
  deleteForm,
  getFormsSelect,
  // Field Types
  getFieldTypes,
  getFieldTypesGrouped,
  // Fields
  getFields,
  getField,
  createField,
  updateField,
  deleteField,
  duplicateField,
  reorderFields,
  // Conditions
  getConditions,
  createCondition,
  updateCondition,
  deleteCondition,
  getConditionOperators,
  getConditionActions,
  // Custom Lists
  getCustomLists
}
